import React from 'react';

import './tooltip.scss';


function ToolTip({ text, className, children }: { text: string, className?: string, children: JSX.Element }) {
    return (
        <div className={`_toolTip ${className ? className : ''}`}>
            <div className="_tooltipSpanner">
                {text}
            </div>
            {children}
        </div>
    )
}

export default ToolTip;